import React, { useMemo } from 'react';
import { Input, Container, Row, Col, Text, Divider, Link } from '../../../../../ui-kit';
import PaymentOptions from './PaymentOptions';
import VideoExtrasList from '../../../../VideoExtrasList';
import { getTotalCost } from './PaymentOptions/utils/getTotalCost';
import { withStockAssets } from '../../../../../common/hocs';
import { detachMaster, addExtrasTotalCost } from '../../../../../common/utils';
import { OutputAddonsList } from '../../../../AddonsList';
import '../styles/_addons-payment-v2.scss';



























export function AddonsPaymentV2Component({
  loading,
  videoOutputs,
  addonsSelector,
  video,
  totalCost,
  showCreditInfo,
  orgCreditInfo,
  teamCreditInfo,
  getCurrencySymbol,
  creditCost,
  onSelectTeam,
  isBrief,
  appliedStockAssets,
  loadingStockAssets,
  isSaveDisabled,
  setPurchaseOrderId,
  hasShutterStockAccess,
  isNewDesign,
  onClickTopupCredit,
  showBufferWarning,
  shouldChargeCreditForB2C: shouldChargeB2C,
  paymentMethodNode
}) {
  const totalCredits = `${creditCost} ${creditCost === 1 ? ' Credit' : ' Credits'}`;

  const formattedTotalCost = useMemo(() => {
    if (loadingStockAssets) return '-';

    const initialCost = getTotalCost(totalCost);

    const unsignedTotal = appliedStockAssets.length ?
    addExtrasTotalCost(initialCost, appliedStockAssets.map((t) => ({
      ...t,
      cost: hasShutterStockAccess ? '0' : t.cost
    }))) :
    initialCost;

    return `${getCurrencySymbol()}${unsignedTotal}`;
  }, [totalCost, appliedStockAssets, loadingStockAssets]);

  const { master, withoutMaster } = detachMaster(videoOutputs);
  const {
    readableId = 'ABC123',
    projectType = 'Video',
    product = 'PRO'
  } = video || {};
  return (
    <div className="addons-payment-v2">
      <Container fluid>
        <Row>
          <div className="addons-payment-v2__order-summary">
            <Text
              className="addons-payment-v2__order-summary--title"
              noMargin
              heading5>

              Cost Summary
            </Text>
            <div className="addons-payment-v2__order-summary--content">
              <div className="addons-payment-v2__order-summary--content__addons">
                <div className="addons-payment-v2__order-summary--content__details">
                  <Text heading5 noMargin>
                    {product === 'PRO' ? 'Pro' : 'Elevate'}
                    {' '}
                    Project
                    <Text caption noMargin className="addons-payment-v2__project-readable-id">
                      {projectType}
                      {' '}
                      #
                      {readableId}
                    </Text>
                  </Text>
                  <Text noMargin heading5>{totalCredits}</Text>
                </div>
                <OutputAddonsList
                  videoOutput={master || videoOutputs[0]}
                  additionalOutputs={withoutMaster}
                  addonsSelector={addonsSelector}
                  isBrief={isBrief}
                  isNewDesign={isNewDesign} />

                <VideoExtrasList
                  listExtras={appliedStockAssets}
                  hasShutterStockAccess={hasShutterStockAccess}
                  isInvoice />

              </div>
              <Divider />

              <div className="addons-payment-v2__order-summary--content__sub-total">
                <div className="addons-payment-v2__order-summary--content__details">
                  <Text heading5>Subtotal</Text>
                  <Text heading5>
                    {`${totalCredits} + ${formattedTotalCost} †`}
                  </Text>
                </div>
              </div>
              <Divider />
              <div className="addons-payment-v2__order-summary--content__details">
                <Text heading5 noMargin heading4>Amount Due</Text>
                <Text noMargin heading4>
                  {shouldChargeB2C &&
                  <>
                    {totalCredits}
                    +
                  </>}

                  {formattedTotalCost}
                </Text>
              </div>
            </div>
          </div>
        </Row>
        <Row>
          <Col>
            <div className="addons-payment-v2__topup">
              <Row justify="between">
                <Col><Text heading5 className="addons-payment-v2__topup--header">Payment Details</Text></Col>
                <Col>
                  <div className="addons-payment-v2__topup--link">
                    <Link onClick={onClickTopupCredit || void 0}>
                      Top Up Credits
                    </Link>
                  </div>
                </Col>
              </Row>
            </div>
            {paymentMethodNode}
            <PaymentOptions
              showCreditInfo={showCreditInfo}
              orgCreditInfo={orgCreditInfo}
              teamCreditInfo={teamCreditInfo}
              onSelectTeam={onSelectTeam}
              isSaveDisabled={isSaveDisabled}
              showBufferWarning={showBufferWarning}
              loading={loading} />

            <Input
              className="payments-invoice-modal__purchase-order"
              label="Enter any special billing instructions or PO here (Optional)"
              placeholder="e.g. Bill to acmecorp or bill against PO1234"
              onChange={setPurchaseOrderId} />

          </Col>
        </Row>
      </Container>
    </div>);

}

export default withStockAssets(AddonsPaymentV2Component);